import * as actionTypes from "../actions/actionTypes";

let initialState = {
  allowInactivePopUp: false,
  allowWaitListPopUp: false,
  assessmentCompleted: false,
  assessmentStatus: null,
  currentQuestion: null,
  hasAssessmentAssigned: true,
  lastSelectedOption: null,
  scheduleList: [],
  selectedOptions: [],
  startRatingScale: false,
  waitlistChangeCount: 0,
};

const startAssessment = (state, action) => {
  return {
    ...state,
    assessmentPerc: action.payload.assessmentPerc,
    currentQuestion: action.payload.startQuestion,
    selectedOptions: [],
  };
};

const nextQuestion = (state, action) => {
  return {
    ...state,
    assessmentPerc: action.payload.assessmentPerc,
    currentQuestion: action.payload.nextQuestion,
    isLastQuestion: action.payload.isLast,
    lastSelectedOption: null,
    selectedOptions: [],
  };
};

const previousQuestion = (state, action) => {
  return {
    ...state,
    assessmentPerc: action.payload.assessmentPerc,
    currentQuestion: action.payload.currentQuestion,
    lastSelectedOption: null,
    selectedOptions: [],
  };
};

const optionSelected = (state, action) => {
  return {
    ...state,
    lastSelectedOption: action.payload.selectedOptionFull,
    selectedOptions: action.payload.selectedOptions,
  };
};

const setAssessmentStatus = (state, action) => {
  return {
    ...state,
    assessmentStatus: action.payload,
  };
};

const assessmentCompleted = (state) => {
  return {
    ...state,
    assessmentCompleted: true,
    currentQuestion: null,
    startRatingScale: false,
  };
};

const noAssessment = (state) => {
  return {
    ...state,
    hasAssessmentAssigned: false,
  };
};

const startRatingScale = (state) => {
  return {
    ...state,
    startRatingScale: true,
  };
};

const updateScheduleList = (state, action) => {
  return {
    ...state,
    scheduleList: action.payload.scheduleList,
  };
};

export const allowLoginPopUps = (state, action) => {
  return {
    ...state,
    allowInactivePopUp: action.payload.allowInactivePopUp,
    allowWaitListPopUp: action.payload.allowWaitListPopUp,
  };
};

const disableLoginPopUps = (state) => {
  return {
    ...state,
    allowInactivePopUp: false,
    allowWaitListPopUp: false,
  };
};

const logout = () => {
  return {
    ...initialState,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.START_ASSESSMENT:
      return startAssessment(state, action);

    case actionTypes.NEXT_QUESTION:
      return nextQuestion(state, action);

    case actionTypes.PREVIOUS_QUESTION:
      return previousQuestion(state, action);

    case actionTypes.OPTION_SELECTED:
      return optionSelected(state, action);

    case actionTypes.SET_ASSESSMENT_STATUS:
      return setAssessmentStatus(state, action);

    case actionTypes.START_RATING_SCALE:
      return startRatingScale(state, action);

    case actionTypes.ASSESSMENT_COMPLETED:
      return assessmentCompleted(state, action);

    case actionTypes.UPDATE_SCHEDULE_LIST:
      return updateScheduleList(state, action);

    case actionTypes.ALLOW_LOGIN_POP_UPS:
      return allowLoginPopUps(state, action);

    case actionTypes.DISABLE_LOGIN_POP_UPS:
      return disableLoginPopUps(state, action);

    case actionTypes.NO_ASSESSMENT:
      return noAssessment(state, action);

    case actionTypes.WAITLIST_STATUS_CHANGED:
      return { ...state, waitlistChangeCount: state.waitlistChangeCount + 1 };

    case actionTypes.LOG_OUT:
      return logout(state, action);

    default:
      return state;
  }
};

export default reducer;
